import React, {useCallback, useEffect, useState} from "react";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import Styles from './styles.module.scss';
import {useDispatch, useSelector} from "react-redux";
import {
    editWallet,
    editWalletFailure,
    editWalletSuccess,
    setSettingsEditWalletModalStatus
} from "../../store/cabinet/action";
import {useTranslation} from "react-i18next";

const SettingsEditWalletModal = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const settingsEditWalletModalStatus = useSelector(store => store.cabinet.settingsEditWalletModalStatus);
    const editWalletStatus = useSelector(store => store.cabinet.editWalletStatus);
    const editWalletStatusErr = useSelector(store => store.cabinet.editWalletStatusErr);

    const [wallet, setWallet] = useState('');


    const closeModal = useCallback(() => {
        dispatch(setSettingsEditWalletModalStatus({status: false, data: false}))
        setWallet('');
    }, [dispatch]);


    useEffect(() => {
        if (editWalletStatus){
            closeModal();
            dispatch(editWalletSuccess(false));
        }
    }, [editWalletStatus, closeModal, dispatch]);

    return (
        <Popup
            open={settingsEditWalletModalStatus?.status}
            modal
            nested
            closeOnDocumentClick={false}
            closeOnEscape={false}
            onClose={closeModal}
        >
            <div className={Styles.modalContainer}>
                <div className={Styles.modalCloseBtn} onClick={closeModal}>
                    <div/>
                    <div/>
                </div>
                <div className={Styles.modalContentWrap}>
                    <div className={Styles.modalTitle}>{t('Редактирование кошелька')}</div>
                    <div className={Styles.selectWrap}>
                        <div className={Styles.selectWrapTitle}>{t('Сеть')}</div>
                        <div className={`${Styles.selectWrapCurrentNetworkBox}`}>
                            <div className={Styles.selectWrapCurrentNetworkBoxImgWrap}><img src={settingsEditWalletModalStatus?.data?.blockchain?.logo} alt={settingsEditWalletModalStatus?.data?.blockchain?.name}/></div>
                            <div className={Styles.selectWrapCurrentNetwork}>{settingsEditWalletModalStatus?.data?.blockchain?.name} ({settingsEditWalletModalStatus?.data?.blockchain?.code})</div>
                        </div>
                    </div>
                    <div className={`${Styles.inputWrap} ${editWalletStatusErr?.wallet ? Styles.inputWrapWithErr : null}`}>
                        <div className={Styles.inputTitle}>Wallet</div>
                        <input
                            type="text"
                            placeholder="0x127..."
                            value={wallet}
                            onChange={(e)=>{setWallet(e.target.value)}}
                            onKeyDown={(event)=>{
                                if (editWalletStatusErr?.wallet){
                                    delete editWalletStatusErr?.wallet;
                                    dispatch(editWalletFailure(editWalletStatusErr));
                                }
                            }}
                        />
                        <div className={Styles.inputErr}>{editWalletStatusErr?.wallet ? editWalletStatusErr?.wallet : ''}</div>
                    </div>
                    <div className={Styles.modalContentWrapMainBtn} onClick={()=>{dispatch(editWallet({blockchain_id: settingsEditWalletModalStatus?.data?.blockchain?.id, wallet: wallet}))}}>{t('Редактировать')}</div>
                </div>
            </div>
        </Popup>
    );
};

export default SettingsEditWalletModal;

